import React from "react";

const SvgComponent = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1250_4947)">
        <path
          d="M9.88672 20H3.89062C2.88672 20 2.03516 19.6797 1.42969 19.0742C0.824219 18.4688 0.503906 17.6133 0.503906 16.6055C0.5 12.2617 0.5 8.33984 0.503906 4.61328C0.503906 3.60938 0.828125 2.75781 1.4375 2.15625C2.04688 1.55469 2.89844 1.23438 3.90625 1.23438H7.89062C8.37891 1.23438 8.77734 1.37891 9.04688 1.65234C9.28906 1.89453 9.41406 2.23047 9.41016 2.62109C9.40234 3.44922 8.81641 3.98047 7.91016 3.98438H5.18359H3.92188C3.375 3.98438 3.24609 4.11328 3.24609 4.66797V16.5742C3.24609 17.125 3.375 17.25 3.92578 17.25H9.87891C9.87891 17.25 13.8477 17.25 15.832 17.25C16.3828 17.25 16.5117 17.125 16.5117 16.5703C16.5117 15.918 16.5117 15.2656 16.5117 14.6133C16.5117 13.9375 16.5117 13.2617 16.5117 12.5859C16.5117 11.6797 17.0508 11.0898 17.8789 11.0859H17.8867C18.7188 11.0859 19.2578 11.668 19.2578 12.5703V12.9453C19.2617 14.168 19.2617 15.4336 19.2578 16.6758C19.2539 17.6406 18.9297 18.4688 18.3203 19.0703C17.7109 19.6719 16.8828 19.9922 15.9141 19.9961C15.125 19.9961 14.3359 19.9961 13.5508 19.9961H9.88672V20Z"
          fill="white"
        />
        <path
          d="M9.16794 12.6094C8.7031 12.6094 8.24607 12.3008 8.03123 11.8438C7.7656 11.2773 7.87888 10.6641 8.33591 10.1992C8.90623 9.62109 9.49216 9.03906 10.0586 8.47656L10.6601 7.87891L12.6015 5.94922C13.6445 4.91406 14.6836 3.87891 15.7226 2.83984C15.7422 2.82031 15.7617 2.80078 15.7812 2.77734C15.1484 2.76562 13.7773 2.75781 13.0156 2.75391C12.582 2.75391 12.2148 2.61328 11.957 2.34766C11.7109 2.09766 11.582 1.75391 11.5859 1.35938C11.5937 0.550781 12.1679 0.0078125 13.0117 0.00390625C14.0508 0 15.082 0 16.1172 0C17.1679 0 18.1406 0 19.0937 0.00390625C19.9414 0.00390625 20.4922 0.546875 20.4961 1.38281C20.5039 3.47266 20.5039 5.54297 20.4961 7.54297C20.4922 8.34766 19.9297 8.91406 19.1289 8.91406C18.3281 8.91406 17.7656 8.35156 17.7578 7.55078C17.7539 7.14062 17.75 6.50391 17.7461 5.88672C17.7422 5.43359 17.7422 5 17.7383 4.71094C17.707 4.73828 17.6797 4.76562 17.6523 4.79297C17.0508 5.39844 16.4492 6 15.8476 6.60547C14.0742 8.38672 12.2422 10.2305 10.4297 12.0312C10.1484 12.3047 9.79685 12.4961 9.41794 12.5859C9.33201 12.6016 9.24997 12.6094 9.16794 12.6094Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1250_4947">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgComponent;
